
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Page404",
})
export default class extends Vue {
  public fromUrl = "";

  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     try {
  //       if (
  //         to.redirectedFrom == undefined ||
  //         to.redirectedFrom == null ||
  //         to.redirectedFrom.toString().length == 0
  //       ) {
  //         vm.fromUrl = "";
  //       } else {
  //         vm.fromUrl = "地址是：" + to.redirectedFrom;
  //       }
  //     } catch (error) {
  //       //当前组件的实例
  //     }
  //   });
  // }
}
